<template>
  <div style="width:100%;float:left;">
    <CCard border-color="info">
      <CCardHeader>
        Chat
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize" @click="show = !show">
            <CIcon :name="`cil-chevron-${show ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="show" :duration="400">
        <CCardBody v-show="!loading">
          <div class="chatWrapper" id="wrapper">
            <div class="messageWrapper" v-if="data && data.length" v-for="val in data">
              <div class="message" :class="configureClass(val)">
                <div class="user">{{val.user.name}}</div>
                <div class="date">{{val.local_created_at}}</div>
                <!-- <hr style="width:100%;float:left;height:1px;background-color:#d9d9d9;" /> -->
                <div class="text">{{val.text}}</div>
              </div>
            </div>
            <div class="noMessages" v-else>
              No messages have been sent...
            </div>
          </div>
          <div class="typingWrapper">
            <textarea class="form-control" @keyup.enter="submitMessage()" :disabled="submitted" v-model="text" rows="3"></textarea>
            <CButton class="btn btn-sm btn-info messageButton" @click="submitMessage()" :disabled="submitted || !text">Submit</CButton>
          </div>
        </CCardBody>
        <CCardBody v-show="loading">
          <small-loader></small-loader>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>
<script>
var moment = require('moment-timezone');
var methods = {}

methods.getChat = function () {
  this.loading = true
  axios.get(this.$apiAdress + '/api/chat/getByGroupId/' + this.order_group_id + '?token=' + localStorage.getItem('api_token'))
  .then(response => {
    console.log('chattttt')
    console.log(response)
    this.data = response.data
    var that = this
    setTimeout(function () {
      that.scrollToBottom()
      that.loading = false
    }, 100)
  }).catch(e => {
    console.log(e)
  })
}

methods.submitMessage = function () {
  this.submitted = true
  const postData = {
    text: this.text,
    order_group_id: this.order_group_id,
    order_id: this.order_id
  }
  axios.post(this.$apiAdress + '/api/chat/submit?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    if (this.data) {
      this.data.push(response.data)
    } else {
      this.data = [response.data]
    }
    this.text = ''
    this.submitted = false
    var that = this
    setTimeout(function () {
      that.scrollToBottom()
    }, 100)
  }).catch(e => {
    console.log(e)
    this.submitted = false
  })
}

methods.configureTime = function (date) {
  // moment().tz().guess()
  var date = moment.tz(date, this.timezone).format('YYYY-MM-DD hh:mm:ss a')
  return date
}

methods.configureClass = function (val) {
  if (this.$store.state.user) {
    if (val.user_id === this.$store.state.user.id) {
      return 'mine'
    } else {
      return 'theirs'
    }
  } else {
    return 'theirs'
  }
}

methods.scrollToBottom = function () {
  console.log($('#wrapper'))
  $('#wrapper').scrollTop($('#wrapper')[0].scrollHeight);
}

export default {
    // ===Component name
    name: "GroupChat",
    // ===Props passed to component
    props: ['order_group_id', 'order_id'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          text: '',
          data: null,
          submitted: false,
          timezone: '',
          show: true,
          loading: true
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.timezone = moment.tz.guess()
      this.getChat()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .chatWrapper {
    width: 100%;
    margin-left:auto;
    margin-right:auto;
    float:left;
    border: 1px solid #e0e0e0;
    height: 400px;
    overflow-y: scroll;

    .noMessages {
      width:100%;
      text-align:center;
      float:left;
    }

    .messageWrapper {
      width: 100%;
      float:left;
      padding:5px;

      .user {

      }

      .message {
        max-width:90%;
        height: auto;
        padding:2px 5px;
        border-radius:5px;

        .user {
          width:100%;
          float:left;
          font-size:10px;
          color:#6e6e6e;
        }

        .date {
          width:100%;
          float:left;
          font-size: 10px;
          color:#6e6e6e;
        }

        &.mine {
          float:right;
          background-color: #8ac0ff;
        }

        &.theirs {
          float:left;
          background-color: #d9d9d9;
        }
      }

    }
  }

  .typingWrapper {
    width: 100%;
    float:left;
    margin-top:5px;
    margin-bottom:15px;

    textarea {
      border-bottom-left-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }

    .messageButton {
      width:100%;
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
    }
  }
</style>
